export const CAR_CUSTOMIZER_CONFIRM_HEADING = 'CAR_CUSTOMIZER_CONFIRM_HEADING';
export const CAR_CUSTOMIZER_CONFIRM_MESSAGE = 'CAR_CUSTOMIZER_CONFIRM_MESSAGE';
export const HAVE_FURTHER_QUESTIONS = 'HAVE_FURTHER_QUESTIONS';
export const GIVE_US_A_CALL_AT = 'GIVE_US_A_CALL_AT';
export const NEED_TO_MAKE_A_CHANGE = 'NEED_TO_MAKE_A_CHANGE';
export const START_A_NEW_VEHICLE_REQUEST = 'START_A_NEW_VEHICLE_REQUEST';
export const DEFAULT_IMAGE_WIDTH = 640;
export const DEFAULT_IMAGE_WIDTH_MOBILE_TRAY = 45;
export const DIESEL_VALUE = 'Diesel';
export const NR_LOGGING_ATTR_PREFIX = 'ws-car-customizer';
export const TRIM_DESCRIPTION_UNAVAILABLE = 'TRIM_DESCRIPTION_UNAVAILABLE';
export const FRONT_LEFT_SHOT_TYPE = 502;
export const MIN_VEHICLE_IMAGE_HEIGHT = 480;
